// import React, { useState } from "react";
// import Card from "components/card";
// import { MdClose } from "react-icons/md";
// import { FaCar } from "react-icons/fa";

// const CarModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     type: "",
//     capacity: "",
//     price: "",
//     pickupDate: "",
//     returnDate: ""
//   });

//   React.useEffect(() => {
//     if (editingItem) {
//       setFormData({
//         name: editingItem.name || "",
//         type: editingItem.type || "",
//         capacity: editingItem.capacity || "",
//         price: editingItem.price || "",
//         pickupDate: editingItem.pickupDate || "",
//         returnDate: editingItem.returnDate || ""
//       });
//     } else {
//       setFormData({ name: "", type: "", capacity: "", price: "", pickupDate: "", returnDate: "" });
//     }
//   }, [editingItem, isOpen]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     onAdd(formData);
//     setFormData({ name: "", type: "", capacity: "", price: "", pickupDate: "", returnDate: "" });
//     onClose();
    
//     // Trigger auto-save by dispatching custom event
//     setTimeout(() => {
//       window.dispatchEvent(new CustomEvent('cartesUpdated'));
//     }, 600);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
//       <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
//         <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-6 rounded-t-[20px]">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-3">
//               <div className="rounded-full bg-white p-2">
//                 <FaCar className="h-6 w-6 text-orange-500" />
//               </div>
//               <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Vehicle Details' : 'Add Vehicle Details'}</h3>
//             </div>
//             <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
//               <MdClose className="h-6 w-6" />
//             </button>
//           </div>
//         </div>
        
//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
          
          
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Pickup Date</label>
//               <input
//                 type="date"
//                 value={formData.pickupDate}
//                 onChange={(e) => setFormData({...formData, pickupDate: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-orange-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Return Date</label>
//               <input
//                 type="date"
//                 value={formData.returnDate}
//                 onChange={(e) => setFormData({...formData, returnDate: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-orange-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
//           </div>
          
//           <div className="flex space-x-4 pt-4">
//             <button
//               type="submit"
//               className="flex-1 rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 py-3 px-6 text-white font-semibold hover:from-orange-600 hover:to-orange-700 transform hover:scale-105 transition-all duration-200 shadow-lg"
//             >
// {editingItem ? 'Update Vehicle' : 'Add Vehicle'}
//             </button>
//             <button
//               type="button"
//               onClick={onClose}
//               className="flex-1 rounded-xl bg-gray-100 py-3 px-6 text-gray-700 font-semibold hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-colors"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </Card>
//     </div>
//   );
// };

// export default CarModal;

import React, { useState, useEffect } from "react";
import Card from "components/card";
import { MdClose } from "react-icons/md";
import { FaCar } from "react-icons/fa";

// Dummy vehicles
const dummyCars = [
  { id: 1, name: "Toyota Corolla", type: "Sedan", capacity: "4", price: "50" },
  { id: 2, name: "Honda CRV", type: "SUV", capacity: "5", price: "70" },
  { id: 3, name: "Ford Transit", type: "Van", capacity: "8", price: "100" },
];

const CarModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    pickupDate: "",
    returnDate: ""
  });
  const [availableCars, setAvailableCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);
  const [searching, setSearching] = useState(false);

  const getTodayDate = () => {
    const d = new Date();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  useEffect(() => {
    if (editingItem) {
      setFormData({
        pickupDate: editingItem.pickupDate || getTodayDate(),
        returnDate: editingItem.returnDate || getTodayDate()
      });
      setSelectedCar(editingItem);
    } else {
      setFormData({ pickupDate: getTodayDate(), returnDate: getTodayDate() });
      setSelectedCar(null);
    }
    setAvailableCars([]);
  }, [editingItem, isOpen]);

  const handleSearch = () => {
    setSearching(true);
    setTimeout(() => {
      setAvailableCars(dummyCars); // always show dummy cars
      setSearching(false);
    }, 500);
  };

  const handleSelectCar = (car) => {
    setSelectedCar(car);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedCar) {
      alert("Please select a vehicle first");
      return;
    }
    const finalData = { ...formData, ...selectedCar };
    onAdd(finalData);
    onClose();

    // Trigger auto-save event
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("cartesUpdated"));
    }, 600);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-6 rounded-t-[20px]">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-full bg-white p-2">
                <FaCar className="h-6 w-6 text-orange-500" />
              </div>
              <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Vehicle Details' : 'Add Vehicle Details'}</h3>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-4">
          {/* Date Inputs */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Pickup Date</label>
              <input
                type="date"
                value={formData.pickupDate}
                onChange={(e) => setFormData({ ...formData, pickupDate: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-orange-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Return Date</label>
              <input
                type="date"
                value={formData.returnDate}
                onChange={(e) => setFormData({ ...formData, returnDate: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-orange-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
          </div>

          {/* Search Button */}
          <button
            onClick={handleSearch}
            disabled={searching}
            className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold hover:bg-orange-600 transition-colors"
          >
            {searching ? "Searching..." : "Search Vehicles"}
          </button>

          {/* Vehicle List */}
          {availableCars.length > 0 && (
            <div className="mt-4 space-y-2 max-h-64 overflow-y-auto">
              {availableCars.map(car => (
                <div
                  key={car.id}
                  onClick={() => handleSelectCar(car)}
                  className={`p-3 border rounded-xl cursor-pointer flex justify-between items-center ${
                    selectedCar?.id === car.id ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <div>
                    <p className="font-semibold">{car.name}</p>
                    <p className="text-sm text-gray-500">{car.type} - Capacity: {car.capacity}</p>
                  </div>
                  <p className="font-semibold">${car.price}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 flex gap-4">
          <button
            onClick={handleSubmit}
            disabled={!selectedCar}
            className="flex-1 bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 rounded-xl font-semibold hover:from-orange-600 hover:to-orange-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50"
          >
            {editingItem ? 'Update Vehicle' : 'Add Vehicle'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-100 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      </Card>
    </div>
  );
};

export default CarModal;
